import gql from 'graphql-tag'
import { ARTICLE_LIST_FRAGMENT } from './articles'

export const ARTICLE = gql`
  query Article($id: String!) {
    article(id: $id) {
      ...ArticleListFragment
      supplierNr
      description
      collection
      modelName
      eancode
      articleType
      inStock
      isWebshopSale
      ignoreStockCheck
      isPriceVisible
      isWebShopOnly
      isOutOfCollection
      collectionNumber
      articleAttributes {
        attributeName
        attributeID
        attributeValueID
        attributeValue
        attributeValue
        attributeOriginalName
      }
    }
  }
  ${ARTICLE_LIST_FRAGMENT}
`
